import { HasOnComplete, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";


export interface DisplayFormOrderParameter extends ApiParameter{
    DisplayType: string;
    DisplayOption: string;
    PoNumber: string;
    OrderNumber: string;
    SelectedSamples: string;
    OrderDate: string;
    ShipTo: ShipTo;
}
export interface ShipTo {
    Name: string;
    Address1: string;
    Address2: string;
    Address3: string;
    City: string;
    State: string;
    Country: string;
    PostalCode: string;
    SideMark: string;
  }

const displayformOrder = "api/v2/displayorder";
export async function displayorder(parameter: DisplayFormOrderParameter) {
    const response = await post<any>(displayformOrder, parameter);
    return response;
}